{
  "401": {
    "title": "Non sei autorizzato ad accedere a questa pagina.",
    "text": "Se pensi che non sia corretto, contatta l'amministratore",
    "back_button": "Torna alla dashboard"
  },
  "403": {
    "title": "Non hai l'autorizzazione per accedere a questa pagina.",
    "text": "Se pensi che sia un errore, contatta l'amministratore.",
    "back_button": "Torna alla dashboard"
  },
  "404": {
    "title": "Questa pagina non è stata trovata.",
    "text": "La pagina richiesta non è stata trovata.",
    "back_button": "Torna alla dashboard"
  },
  "general": {
    "dateFormat": "dd/MM/yyyy",
    "fullDateFormat": "dd/MM/yyyy HH:mm:ss",
    "logout": "Disconnessione",
    "account": "Account",
    "profile": "Profilo",
    "hello": "Ciao",
    "home": "Home",
    "loading": "Caricamento...",
    "confirm": "Conferma",
    "cancel": "Annulla",
    "close": "Chiudi",
    "view": "Visualizza",
    "save": "Salva",
    "records": "Record",
    "add": "Aggiungi",
    "read": "Leggi",
    "write": "Scrivi",
    "edit": "Modifica",
    "new": "Nuovo",
    "delete": "Elimina",
    "actions": "Azioni",
    "active": "Attivo",
    "inactive": "Inattivo",
    "search": "Cerca",
    "select": "Seleziona",
    "none": "Nessuno",
    "yes": "Sì",
    "no": "No",
    "years": "Anni",
    "months": "Mesi",
    "favorites": "Preferiti",
    "reports": "Report",
    "recordsPerPage": "Record per pagina",
    "changePassword": "Cambia password",
    "longDateFormat": "{years} anno/i e {months} mese/i",
    "importData": "Importa dati",
    "upload": "Carica",
    "downloadTemplate": "Scarica modello",
    "selectOption": "Seleziona un'opzione",
    "id": "ID",
    "translations": "Traduzioni",
    "or": "o",
    "review": "Rivedi",
    "approve": "Approva",
    "reject": "Rifiuta",
    "reviewComments": "Commenti di Revisione",
    "reviewOnBehalfOf": "Rivedi per conto di",
    "reviewed": "Rivisto",
    "reviewedBy": "Rivisto Da ",
    "pending": "In sospeso",
    "approved": "Approvato",
    "rejected": "Rifiutato",
    "skipped": "Saltato",
    "warning": "Avviso",
    "move": "Sposta",
    "leave": "Esci",
    "export": "Esporta",
    "import": "Importa",
    "next": "Avanti",
    "previous": "Indietro",
    "done": "Fatto",
    "run": "Esegui",
    "form": "Modulo",
    "emailTemplate": "Modello Email",
    "send": "Invia",
    "saving": "Salvataggio...",
    "saved": "Salvato",
    "loadData": "Carica Dati",
    "exportCsv": "Esporta CSV",
    "auditFields": "Campi di audit",
    "saveDisplayOrder": "Salva ordine di visualizzazione",
    "attach": "Allega",
    "permissionActions": {
      "read": "Leggi",
      "write": "Scrivi",
      "delete": "Elimina",
      "execute": "Esegui"
    },
    "messages": {
      "formUnsavedChanges": "Hai modifiche non salvate. Sei sicuro di voler chiudere?",
      "serverError": "Errore del server. Riprova più tardi o contatta l'amministratore del sistema.",
      "networkError": "Impossibile connettersi al server. Controlla la tua connessione internet o contatta l'amministratore del sistema.",
      "forbidden": "Non hai l'autorizzazione per accedere a questa risorsa. Contatta l'amministratore del sistema se pensi che sia un errore.",
      "fileUploadError": "Errore durante il caricamento del file. Controlla il formato e la dimensione del file e riprova.",
      "fileUploadSuccessEmail": "File caricato con successo. Un'email con il risultato dell'importazione verrà inviata a breve.",
      "failedLoadPermissions": "Caricamento delle autorizzazioni utente fallito. Aggiorna la pagina o contatta l'amministratore del sistema.",
      "downloadingFile": "Download del file in corso...",
      "fileDownloadError": "Errore durante il download del file. Riprova o contatta l'amministratore del sistema.",
      "fileImportedSuccessfully": "File importato con successo.",
      "invalidFileFormat": "Formato file non valido. Controlla il file e riprova.",
      "exportFailed": "Impossibile esportare i dati. Riprova o contatta l'amministratore di sistema.",
      "personNotFound": "Persona non trovata. Contatta l'amministratore.",
      "notRegisteredSessionOnly": "Non sei registrato in JTP, quindi questa modifica verrà applicata solo alla sessione corrente. Contatta l'amministratore per essere aggiunto.",
      "unableGetPermissions": "JTP non riesce a ottenere le tue autorizzazioni. Puoi lavorare con un accesso di base finché questo problema non sarà risolto."
    },
    "warnings": {
      "maxDisplayedRecords": "Visualizzazione di {shown} record su {filtered}. Per visualizzare altri record, utilizza la funzione di ricerca."
    },
    "validation": {
      "required": "Questo campo è obbligatorio.",
      "email": "Inserisci un indirizzo email valido.",
      "minValue": "Il valore deve essere almeno {min}.",
      "maxValue": "Il valore non può essere maggiore di {max}.",
      "minLength": "Il valore deve essere lungo almeno {min} caratteri.",
      "maxLength": "Il valore non può essere più lungo di {max} caratteri.",
      "onlyIntegers": "Il valore deve essere un numero intero.",
      "invalidDate": "La data inserita non è valida."
    },
    "baseAuditableEntity": {
      "createdBy": "Creato da",
      "createdDate": "Data di creazione",
      "modifiedBy": "Modificato da",
      "modifiedDate": "Data di modifica"
    },
    "info": {
      "dragAndDropInfo": "Trascina e rilascia qualsiasi persona per organizzare l'albero"
    },
    "download": "Scarica",
    "noData": "Nessun dato disponibile nella tabella",
    "cropImage": "Ritaglia immagine",
    "selectImageToCrop": "Seleziona un'immagine da ritagliare",
    "selectImage": "Seleziona immagine",
    "list": "Elenco",
    "group": "Gruppo",
    "manager": "Manager",
    "status": "Stato"
  },
  "enums": {
    "potentialSuccessorType": {
      "1": "Interno",
      "2": "Esterno"
    },
    "readinessFactor": {
      "0": "N/A",
      "1": "Pronto Ora",
      "2": "Pronto con Sviluppo (1-2 Anni)",
      "3": "Pronto con Sviluppo (2-3 Anni)",
      "4": "Sostituzione d'Emergenza"
    },
    "positionType": {
      "1": "Acquistare",
      "2": "Produrre",
      "3": "Vendere",
      "4": "Supporto"
    },
    "communicationPriority": {
      "1": "Normale",
      "2": "Alta"
    }
  },
  "report": {
    "viewer": {
      "grid": {
        "pivotMode": "Modalità Pivot",
        "groups": "Gruppi di Righe",
        "rowGroupColumnsEmptyMessage": "Trascina qui per impostare i gruppi di righe",
        "values": "Valori",
        "valueColumnsEmptyMessage": "Trascina qui per aggregare",
        "pivots": "Etichette di Colonna",
        "pivotColumnsEmptyMessage": "Trascina qui per impostare le etichette di colonna",
        "columns": "Colonne",
        "filters": "Filtri",
        "loadingOoo": "Caricamento...",
        "noRowsToShow": "Nessuna riga da mostrare",
        "enabled": "Abilitato",
        "group": "Gruppo",
        "footerTotal": "Totale",
        "filterOoo": "Filtra...",
        "searchOoo": "Cerca...",
        "blanks": "(Vuoti)",
        "selectAll": "(Seleziona Tutto)",
        "selectAllSearchResults": "(Seleziona Tutti i Risultati della Ricerca)",
        "noMatches": "Nessuna corrispondenza",
        "equals": "Uguale a",
        "notEqual": "Diverso da",
        "blank": "Vuoto",
        "notBlank": "Non vuoto",
        "lessThan": "Minore di",
        "greaterThan": "Maggiore di",
        "lessThanOrEqual": "Minore o uguale a",
        "greaterThanOrEqual": "Maggiore o uguale a",
        "inRange": "Tra",
        "inRangeStart": "Da",
        "inRangeEnd": "A",
        "contains": "Contiene",
        "notContains": "Non contiene",
        "startsWith": "Inizia con",
        "endsWith": "Finisce con",
        "before": "Prima",
        "after": "Dopo",
        "andCondition": "E",
        "orCondition": "O",
        "applyFilter": "Applica",
        "resetFilter": "Reimposta",
        "clearFilter": "Cancella",
        "cancelFilter": "Annulla",
        "textFilter": "Filtro di Testo",
        "numberFilter": "Filtro Numerico",
        "dateFilter": "Filtro Data",
        "setFilter": "Filtro Set",
        "pinColumn": "Blocca Colonna",
        "pinLeft": "Blocca a Sinistra",
        "pinRight": "Blocca a Destra",
        "noPin": "Non Bloccare",
        "valueAggregation": "Aggregazione Valori",
        "noAggregation": "Nessuna",
        "autosizeThisColumn": "Adatta Questa Colonna",
        "autosizeAllColumns": "Adatta Tutte le Colonne",
        "groupBy": "Raggruppa per",
        "ungroupBy": "Separa per",
        "ungroupAll": "Separa Tutto",
        "addToValues": "Aggiungi {'${variable}'} ai valori",
        "removeFromValues": "Rimuovi {'${variable}'} dai valori",
        "addToLabels": "Aggiungi {'${variable}'} alle etichette",
        "removeFromLabels": "Rimuovi {'${variable}'} dalle etichette",
        "resetColumns": "Reimposta Colonne",
        "expandAll": "Espandi Tutti i Gruppi di Righe",
        "collapseAll": "Comprimi Tutti i Gruppi di Righe",
        "copy": "Copia",
        "copyWithHeaders": "Copia con Intestazioni",
        "copyWithGroupHeaders": "Copia con Intestazioni di Gruppo",
        "cut": "Taglia",
        "paste": "Incolla",
        "export": "Esporta",
        "csvExport": "Esporta CSV",
        "excelExport": "Esporta Excel",
        "sum": "Somma",
        "first": "Primo",
        "last": "Ultimo",
        "min": "Min",
        "max": "Max",
        "count": "Conteggio",
        "avg": "Media",
        "average": "Media",
        "filteredRows": "Filtrate",
        "selectedRows": "Selezionate",
        "totalRows": "Totale Righe",
        "totalAndFilteredRows": "Righe"
      },
      "noFilterMessage": "Nessun filtro per questo report",
      "noAccessReport": "Non hai accesso a questo report. Contatta l'amministratore del sistema se pensi che sia un errore.",
      "pdfSizeErrorMessage": "La dimensione del PDF è troppo grande e non può essere visualizzata.",
      "pdfMaxSizeDownloaded": "Il report è troppo grande per essere visualizzato. Controlla la tua cartella download.",
      "failedLoadReports": "Caricamento report fallito. Le altre funzionalità funzioneranno normalmente. Aggiorna la pagina o contatta l'amministratore del sistema se il problema persiste.",
      "run": "Esegui",
      "download": "Scarica",
      "viewFilter": {
        "button": "Visualizza Filtri...",
        "title": "Parametri",
        "name": "Nome",
        "value": "Valore"
      },
      "fullScreen": "Schermo Intero...",
      "smallScreen": "Schermo Piccolo...",
      "tabButton": {
        "fullScreen": "Nascondi sezione parametri",
        "smallScreen": "Mostra sezione parametri",
        "about": "Info",
        "downloadExcel": "Scarica file Foglio di Calcolo",
        "clear": "Chiudi Tutte le Schede"
      },
      "modalAbout": {
        "title": "Info",
        "description": "Descrizione",
        "version": "Versione",
        "reference": "Riferimento",
        "lastChange": "Ultima Modifica",
        "dataSource": "Origine Dati"
      }
    },
    "maintenance": {
      "menuName": "Report",
      "pageTitle": "Report",
      "id": "ID",
      "title": "Titolo",
      "reference": "Riferimento",
      "directoryTree": "Struttura Directory",
      "directoryTreeHelp": "Usa la barra rovesciata per separare le cartelle, es. Report\\Finanza\\Mensile",
      "reportType": "Tipo di Report",
      "typeGrid": "Griglia",
      "typeForm": "Modulo",
      "securityResource": "Risorsa di Sicurezza",
      "description": "Descrizione",
      "versionNumber": "Versione",
      "isActive": "Attivo",
      "lastModified": "Ultima Modifica",
      "isSchedulable": "Pianificabile",
      "isArchivable": "Archiviabile",
      "isAuditable": "Verificabile",
      "passMultiValue": "Passa Valori Multipli come Stringa",
      "expireInDays": "Scade in Giorni",
      "add": "Aggiungi Report",
      "edit": "Modifica Report",
      "delete": {
        "title": "Elimina Report",
        "text": "Sei sicuro di voler eliminare \"{name}\"?"
      },
      "messages": {
        "created": "Report creato con successo.",
        "updated": "Report salvato con successo.",
        "deleted": "Report eliminato con successo.",
        "imported": "Report importato con successo."
      },
      "sections": {
        "main": "Proprietà Principali",
        "parameters": "Parametri",
        "sqls": "Istruzioni SQL",
        "grids": "Griglie Risultati",
        "models": "Modelli di Report"
      },
      "sql": {
        "add": "Aggiungi Istruzione SQL",
        "edit": "Modifica Istruzione SQL",
        "description": "Descrizione",
        "connection": "Connessione",
        "multipleResultset": "Set di Risultati Multipli",
        "sql": "SQL",
        "generateGrids": "Genera Griglie da SQL",
        "generateGridsSuccess": "Griglia generata con successo. Verificala nella scheda Griglie Risultati.",
        "delete": {
          "title": "Elimina Istruzione SQL",
          "text": "Sei sicuro di voler eliminare \"{name}\"?"
        }
      },
      "grid": {
        "add": "Aggiungi Griglia",
        "edit": "Modifica Griglia",
        "label": "Etichetta",
        "resultsetNumber": "N° Set di Risultati",
        "parentGrid": "Griglia Padre",
        "defaultGroupedColumns": "Colonne Raggruppate Predefinite",
        "relationString": "Stringa di Relazione",
        "delete": {
          "title": "Elimina Griglia",
          "text": "Sei sicuro di voler eliminare \"{name}\"?"
        }
      },
      "column": {
        "add": "Aggiungi Colonna",
        "edit": "Modifica Colonna",
        "columnName": "Nome Colonna",
        "label": "Etichetta",
        "header": "Intestazione",
        "dataType": "Tipo di Dati",
        "sumarizeType": "Riepilogo",
        "showOrder": "Ordine",
        "mask": "Maschera",
        "helpText": "Testo di Aiuto",
        "template": "Modello",
        "delete": {
          "title": "Elimina Colonna",
          "text": "Sei sicuro di voler eliminare \"{name}\"?"
        }
      },
      "param": {
        "add": "Aggiungi Parametro",
        "edit": "Modifica Parametro",
        "displayOrder": "Ordine",
        "name": "Nome",
        "nameValidation": "Sono consentiti solo lettere, numeri e trattini bassi.",
        "label": "Etichetta",
        "dataType": "Tipo di Dati",
        "defaultValue": "Valore Predefinito",
        "helpText": "Testo di Aiuto",
        "required": "Obbligatorio",
        "multiple": "Valori Multipli",
        "width": "Larghezza (col)",
        "enumValues": "Valori (separati da punto e virgola)",
        "enumValuesHelp": "es. 1;2;3",
        "enumLabels": "Etichette (separate da punto e virgola)",
        "enumLabelsHelp": "es. Opzione A;Opzione B;Opzione C",
        "sql": "Query SQL",
        "generate": "Genera parametri da SQL",
        "delete": {
          "title": "Elimina Parametro",
          "text": "Sei sicuro di voler eliminare \"{name}\"?"
        }
      },
      "model": {
        "add": "Aggiungi Modello",
        "edit": "Modifica Modello",
        "description": "Descrizione",
        "order": "Ordine",
        "connection": "Connessione",
        "file": "File Modello (.trdx / .trdp)",
        "fileLoaded": "File caricato con successo.",
        "delete": {
          "title": "Elimina Modello",
          "text": "Sei sicuro di voler eliminare \"{name}\"?"
        }
      },
      "paramDataType": {
        "text": "Testo",
        "number": "Numero",
        "date": "Data",
        "time": "Ora",
        "combo": "Combo",
        "boolean": "Booleano",
        "sql": "SQL"
      },
      "colDataType": {
        "text": "Testo",
        "number": "Numero",
        "date": "Data",
        "time": "Ora",
        "combo": "Combo",
        "boolean": "Booleano"
      },
      "sumarizeType": {
        "nosumarize": "Nessuno",
        "sum": "Somma",
        "min": "Min",
        "max": "Max",
        "average": "Media",
        "count": "Conteggio"
      },
      "import": {
        "connection": "Override Connessione",
        "connectionHelp": "Opzionale: sostituisce tutti i riferimenti di connessione nel file importato."
      }
    }
  },
  "file": {
    "description": "Descrizione",
    "files": "File",
    "editDescription": "Modifica Descrizione",
    "delete": "Elimina File",
    "download": "Scarica File",
    "pendingUpload": "Caricamento in sospeso. Il file verrà salvato solo dopo aver cliccato su 'Salva'.",
    "noFiles": "Nessun file aggiunto."
  },
  "dashboard": {
    "menuTitle": "Dashboard",
    "title": "Dashboard",
    "addWidget": "Aggiungi Widget",
    "editLayout": "Modifica Layout",
    "saveLayout": "Salva Layout",
    "importLayout": "Importa Layout",
    "exportLayout": "Esporta Layout",
    "category": "Categoria",
    "widget": "Widget",
    "widgetTitle": "Titolo",
    "widgetParameters": "Parametri",
    "widgetInformation": "Informazioni Widget",
    "noParameters": "Questo widget non ha parametri.",
    "delete": "Elimina Widget",
    "viewLink": "visualizza",
    "noItemsToDisplay": "Nessun elemento da visualizzare",
    "messages": {
      "saveSuccess": "Layout salvato con successo.",
      "importSuccess": "Layout importato con successo.",
      "exportSuccess": "Layout esportato con successo.",
      "importFailed": "Importazione layout fallita.",
      "widgetNotFound": "Widget non trovato",
      "failedToLoad": "Caricamento fallito",
      "noDataAvailable": "Nessun dato disponibile",
      "noParametersConfigured": "Nessun parametro configurato per questo widget."
    },
    "tutorial": {
      "mainMessage": "Benvenuto nella tua dashboard! Usa i pulsanti sopra per personalizzarla.",
      "callToAction": "Mostrami come!",
      "instructions": {
        "add": {
          "title": "Pulsante Aggiungi Widget",
          "description": "Qui potrai trovare widget per categoria. Alcuni di essi possono avere parametri per permetterti una dashboard completamente personalizzabile. Non dimenticare di premere SALVA dopo aver aggiunto tutti i tuoi widget."
        },
        "edit": {
          "title": "Modifica Layout Widget",
          "description": "Qui potrai modificare la tua dashboard: Aggiungere o rimuovere widget, spostarli e ridimensionarli. Non dimenticare di salvare dopo la modifica."
        },
        "import": {
          "title": "Importa Layout",
          "description": "Con un file di backup, qui puoi importarlo. Nota: La tua dashboard sarà sovrascritta."
        },
        "export": {
          "title": "Esporta Layout",
          "description": "Una volta completata la tua dashboard, puoi esportarla per avere un backup OPPURE inviarla ad un altro utente per copiare la tua dashboard."
        }
      }
    }
  },
  "communication": {
    "title": "Comunicazioni",
    "menuTitle": "Comunicazioni",
    "menuName": "Comunicazioni",
    "inbox": "Posta in arrivo",
    "markAsRead": "Segna come Letto",
    "subject": "Oggetto",
    "date": "Data",
    "priority": "Priorità",
    "backToInbox": "Torna alla posta in arrivo",
    "noMessages": "Nessun messaggio nella posta in arrivo.",
    "status": "Stato",
    "read": "Letto",
    "unread": "Non Letto",
    "edit": "Visualizza",
    "messages": {
      "markedAsRead": "Comunicazione ricevuta"
    }
  },
  "settings": {
    "title": "Impostazioni",
    "theme": {
      "name": "Tema",
      "dark": "Scuro",
      "light": "Chiaro"
    }
  },
  "userInfo": {
    "title": "Informazioni Utente",
    "permissions": "Autorizzazioni",
    "userName": "Nome utente",
    "fullName": "Nome Completo",
    "email": "Email",
    "employeeId": "ID Dipendente",
    "action": "Azione",
    "permissionCode": "Codice Autorizzazione"
  },
  "profile": {
    "title": "Il mio profilo",
    "menuName": "Profilo",
    "score": "Punteggio del profilo",
    "managerWarning": "Le informazioni fornite nella pagina 'Il mio Profilo' sono accessibili ai Manager e al Dipartimento HR dell'organizzazione per fini di Talent Mapping.",
    "photo": "Cambia immagine",
    "name": "Nome",
    "email": "E-mail",
    "manager": "Manager",
    "position": "Posizione",
    "plant": "Sede",
    "businessArea": "Area commerciale",
    "degreeType": "Titolo di Studio",
    "degreeName": "Nome del Diploma o Certificato",
    "language": "Lingua",
    "languagesInfo": "Seleziona tutte le lingue che parli",
    "geoMobility": {
      "label": "Mobilità geografica",
      "none": "Nessuno",
      "local": "Locale",
      "national": "Nazionale",
      "international": "Internazionale",
      "nationalAndInternational": "Nazionale e Internazionale"
    },
    "businessMobility": "Unità mobile operativa",
    "skills": "Le mie competenze",
    "skillsInfo": "Seleziona le tue aree di competenza",
    "careerInterests": "Interessi professionali",
    "careerAspirations": "Aspirazioni di carriera",
    "jobHistory": "Storia lavorativa rilevante",
    "save": "Salva",
    "invalidPhotoFormat": "Immagine con un'estensione non valida",
    "photoCrop": {
      "title": "Foto del profilo",
      "selectImage": "Carica",
      "confirm": "Applica",
      "cancel": "Annulla",
      "deletePhoto": "Rimuovi",
      "hint": "Trascina per riposizionare. Pizzica o scorri per ingrandire.",
      "emptyState": "Nessuna immagine selezionata. Clicca su \"Carica\" per iniziare."
    },
    "messages": {
      "saved": "Profilo salvato con successo",
      "notRegistered": "Non sei registrato in JTP. Contatta le Risorse Umane per essere aggiunto. Fino ad allora, il tuo accesso sarà limitato."
    }
  },
  "impersonate": {
    "title": "Impersona Utente",
    "userName": "Login",
    "start": "Inizia Impersonificazione",
    "messages": {
      "impersonationStarted": "Sessione di impersonificazione iniziata. Per tornare al tuo account, effettua il logout e riconnettiti.",
      "userNotFound": "Utente non trovato. Controlla il nome utente e riprova."
    }
  },
  "about": {
    "menuName": "Info",
    "title": "Info"
  },
  "releaseNotes": {
    "menuName": "Note di Rilascio",
    "title": "Note di Rilascio",
    "name": "Nome",
    "version": "Versione",
    "description": "Descrizione",
    "appType": "Tipo Applicazione",
    "releaseDate": "Data di Rilascio",
    "messages": {
      "notFound": "Nota di rilascio non trovata.",
      "saveError": "Errore nel salvataggio della nota di rilascio. Riprova più tardi."
    }
  },
  "help": {
    "menuTitle": "Aiuto",
    "externalLinkMessage": "Stai per aprire un collegamento esterno:",
    "externalLinkConfirm": "Apri collegamento",
    "lastUpdated": "Ultimo aggiornamento: {date}",
    "wasThisHelpful": "È stato utile?",
    "helpful": "Utile",
    "notHelpful": "Non utile",
    "pageModal": {
      "title": "Aiuto per questa pagina",
      "intro": "Gli articoli della guida offrono indicazioni per la pagina in cui ti trovi. Selezionane uno per aprirlo o chiudi questa finestra."
    }
  },
  "admin": {
    "menuTitle": "Amministrazione",
    "appCustomizations": {
      "menuName": "Personalizzazioni App",
      "pageTitle": "Personalizzazioni App",
      "imageLogos": "Loghi Immagine",
      "headerLogo": "Logo Intestazione",
      "menuLogo": "Logo Menu",
      "bannerImage": "Immagine Banner",
      "upload": "Carica",
      "remove": "Rimuovi",
      "deleteConfirmTitle": "Rimuovi immagine",
      "deleteConfirmText": "Sei sicuro di voler rimuovere questa immagine? Questa azione non può essere annullata.",
      "noCustom": "Immagine predefinita",
      "preview": "Anteprima",
      "messages": {
        "saved": "Personalizzazioni salvate con successo.",
        "invalidKey": "Chiave logo non valida.",
        "invalidLanguage": "Codice lingua non valido.",
        "fileRequired": "Il file è obbligatorio.",
        "fileTooLarge": "Il file supera la dimensione massima consentita di 2 MB.",
        "fileTypeNotAllowed": "Tipo di file non consentito. Usare PNG, JPEG o WebP.",
        "notFound": "Personalizzazione non trovata."
      }
    },
    "help": {
      "menuName": "Aiuto",
      "pageTitle": "Aiuto",
      "title": "Titolo",
      "description": "Descrizione",
      "isActive": "Attivo",
      "displayOrder": "Ordine di visualizzazione",
      "securityResources": "Risorse di sicurezza",
      "securityResourcesInfo": "Elenco di permessi separati da virgole. Lascia vuoto per renderlo visibile a tutti; altrimenti l'utente deve avere almeno uno dei permessi indicati.",
      "isMenuDisplayed": "Mostra nel menu",
      "isMenuDisplayedInfo": "Se disattivato, questa guida è nascosta dal menu Aiuto, ma può comunque essere aperta dall'icona della guida nelle pagine associate.",
      "isTrackingEnabled": "Abilita tracciamento",
      "isTrackingEnabledInfo": "Se attivo, le visualizzazioni vengono registrate per dipendente e nella pagina della guida viene mostrata una valutazione \"è stato utile\".",
      "viewCount": "Visualizzazioni",
      "viewCountValue": "Visto {views} volte da {viewers} persone",
      "viewCountInfo": "Numero totale di visualizzazioni e numero di dipendenti distinti che hanno aperto questa guida.",
      "helpfulCount": "Utile",
      "notHelpfulCount": "Non utile",
      "associatedMenus": "Pagine associate",
      "associatedMenusInfo": "Collega questa guida a una o più pagine in modo che possa essere aperta direttamente dall'icona della guida in quelle pagine.",
      "addMenu": "Aggiungi pagina",
      "add": "Aggiungi aiuto",
      "edit": "Modifica aiuto",
      "delete": {
        "title": "Elimina aiuto",
        "text": "Sei sicuro di voler eliminare questa voce di aiuto?"
      },
      "messages": {
        "created": "Aiuto creato con successo.",
        "updated": "Aiuto aggiornato con successo.",
        "deleted": "Aiuto eliminato con successo.",
        "notFound": "Aiuto non trovato."
      }
    },
    "menuHierarchy": {
      "menuName": "Gerarchia Menu",
      "pageTitle": "Gerarchia Menu",
      "displayName": "Nome Visualizzato",
      "route": "Menu Route",
      "routeParam": "Parametro Menu",
      "securityResources": "Risorse di Sicurezza",
      "children": "Sotto-Menu",
      "isActive": "È Attivo",
      "icon": "Icona",
      "iconHelpText": "Libreria di icone",
      "displayOrder": "Ordine di Visualizzazione",
      "edit": "Modifica Elemento Menu",
      "messages": {
        "success": "Elemento menu salvato con successo."
      }
    },
    "notificationTemplate": {
      "menuName": "Template Notifica",
      "pageTitle": "Template Notifica",
      "name": "Nome",
      "parent": "Template Genitore",
      "parentInfo": "Solo i template che iniziano con masterTemplate possono essere usati come template genitore.",
      "pushNotificationEnabled": "Notifica Push Abilitata",
      "pushRoute": "Route Notifica Push",
      "sqlQuery": "Query SQL",
      "sqlQueryDateFormatInfo": "Le colonne data devono essere formattate nel formato MM/dd/yyyy.",
      "generalSection": "Informazioni Generali",
      "emailSection": "Notifica Email",
      "emailSubject": "Oggetto Email",
      "emailBody": "Corpo Email (HTML)",
      "pushSection": "Notifica Push",
      "pushSubject": "Oggetto Push",
      "pushBody": "Corpo Push",
      "overrideNotificationTemplate": "Sovrascrivi Template Notifica",
      "add": "Aggiungi Template",
      "edit": "Modifica Template",
      "delete": {
        "title": "Elimina Template",
        "text": "Sei sicuro di voler eliminare il template \"{name}\"?"
      },
      "attachment": {
        "title": "Allega File",
        "attachment": "File Allegato",
        "attach": "Allega",
        "noAttachedFile": "Nessun file allegato...",
        "messages": {
          "uploadedSuccessfully": "File allegato caricato con successo."
        },
        "delete": {
          "title": "Elimina File Allegato",
          "text": "Sei sicuro di voler eliminare il file allegato \"{name}\"?"
        }
      },
      "messages": {
        "created": "Template notifica creato con successo.",
        "updated": "Template notifica aggiornato con successo.",
        "deleted": "Template notifica eliminato con successo.",
        "alreadyExists": "Un template notifica con questo nome esiste già.",
        "fileRequired": "Il file è obbligatorio.",
        "importError": "Si è verificato un errore durante l'importazione del template notifica.",
        "notFound": "Template di notifica non trovato."
      }
    },
    "department": {
      "menuName": "Dipartimento",
      "pageTitle": "Dipartimento",
      "name": "Nome",
      "isActive": "È Attivo",
      "add": "Aggiungi Dipartimento",
      "edit": "Modifica Dipartimento",
      "delete": {
        "title": "Elimina Dipartimento",
        "text": "Sei sicuro di voler eliminare questo dipartimento?"
      },
      "messages": {
        "created": "Dipartimento creato con successo.",
        "updated": "Dipartimento aggiornato con successo.",
        "deleted": "Dipartimento eliminato con successo."
      }
    },
    "businessArea": {
      "menuName": "Area di Business",
      "pageTitle": "Area di Business",
      "id": "Id",
      "externalId": "Id Esterno",
      "description": "Descrizione",
      "calendarId": "Calendario",
      "isActive": "È Attivo",
      "edit": "Modifica Area di Business",
      "messages": {
        "created": "Area di Business creata con successo.",
        "updated": "Area di Business aggiornata con successo.",
        "deleted": "Area di Business eliminata con successo."
      }
    },
    "businessUnit": {
      "menuName": "Unità di Business",
      "pageTitle": "Unità di Business",
      "id": "Id",
      "externalId": "Id Esterno",
      "description": "Descrizione",
      "isActive": "È Attiva",
      "edit": "Modifica Unità di Business",
      "messages": {
        "created": "Unità di Business creata con successo.",
        "updated": "Unità di Business aggiornata con successo.",
        "deleted": "Unità di Business eliminata con successo.",
        "inUse": "L’Unità di Business è in uso. Eliminare prima le sue dipendenze.",
        "notFound": "Record dell’Unità di Business non trovato"
      },
      "add": "Aggiungi Unità di Business",
      "delete": {
        "title": "Elimina Unità di Business",
        "text": "Sei sicuro di voler eliminare questa Unità di Business?"
      }
    },
    "division": {
      "menuName": "Divisione",
      "pageTitle": "Divisione",
      "id": "Id",
      "externalId": "Id Esterno",
      "description": "Descrizione",
      "isActive": "È Attiva",
      "businessUnitId": "Unità di Business",
      "edit": "Modifica Divisione",
      "messages": {
        "created": "Divisione creata con successo.",
        "updated": "Divisione aggiornata con successo.",
        "deleted": "Divisione eliminata con successo."
      },
      "add": "Aggiungi Divisione",
      "delete": {
        "title": "Elimina Divisione",
        "text": "Sei sicuro di voler eliminare questa Divisione?"
      }
    },
    "organization": {
      "menuName": "Organizzazione",
      "pageTitle": "Organizzazione",
      "id": "ID",
      "externalId": "ID Esterno",
      "name": "Nome",
      "plantAreaId": "Area di Stabilimento",
      "organizationParentId": "Organizzazione Padre",
      "edit": "Modifica Organizzazione",
      "messages": {
        "created": "Organizzazione creata con successo.",
        "updated": "Organizzazione aggiornata con successo.",
        "deleted": "Organizzazione eliminata con successo."
      },
      "add": "Aggiungi Organizzazione",
      "delete": {
        "title": "Elimina Organizzazione",
        "text": "Sei sicuro di voler eliminare questa organizzazione?"
      }
    },
    "plant": {
      "menuName": "Stabilimento",
      "pageTitle": "Stabilimento",
      "id": "Id",
      "name": "Nome",
      "alias": "Alias",
      "isActive": "Attivo",
      "divisionId": "Divisione",
      "countryId": "Paese",
      "employeeCanUpdateGoals": "Il dipendente può aggiornare gli obiettivi",
      "employeeCanUpdateTracks": "Il dipendente può aggiornare i risultati",
      "employeeCanIncludeKPI": "Il dipendente può creare KPI",
      "managerCanUpdateGoals": "Il manager può aggiornare gli obiettivi",
      "managerCanUpdateTracks": "Il manager può aggiornare i risultati",
      "managerCanIncludeKPI": "Il manager può creare KPI",
      "edit": "Modifica Stabilimento",
      "messages": {
        "created": "Stabilimento creato con successo.",
        "updated": "Stabilimento aggiornato con successo.",
        "deleted": "Stabilimento eliminato con successo.",
        "inUse": "Il record dello Stabilimento è in uso. Eliminare prima i record correlati.",
        "notFound": "Stabilimento non trovato"
      },
      "add": "Aggiungi Stabilimento",
      "delete": {
        "title": "Elimina Stabilimento",
        "text": "Sei sicuro di voler eliminare questo Stabilimento?"
      }
    },
    "personnelArea": {
      "menuName": "Area del Personale",
      "pageTitle": "Area del Personale",
      "id": "Id",
      "description": "Descrizione",
      "externalId": "Id Esterno",
      "plantId": "Stabilimento",
      "isActive": "Attivo",
      "sourceModifiedDate": "Data di Modifica Sorgente",
      "edit": "Modifica Area del Personale",
      "messages": {
        "created": "Area del Personale creata con successo.",
        "updated": "Area del Personale aggiornata con successo.",
        "deleted": "Area del Personale eliminata con successo.",
        "inUse": "Il record dell'Area del Personale è in uso. Eliminare prima i relativi utilizzi.",
        "notFound": "Record dell'Area del Personale non trovato",
        "alreadyExists": "Esiste già un'area del personale con questa descrizione.",
        "fileRequired": "Il file è obbligatorio.",
        "importError": "Si è verificato un errore durante l'importazione dell'area del personale.",
        "invalidPlant": "Id Stabilimento non valido",
        "duplicateExternalId": "Id Esterno duplicato",
        "importSuccess": "Area del Personale importata con successo. Riceverai il file via e-mail",
        "exportSuccess": "Area del Personale esportata con successo. Riceverai il file via e-mail",
        "exportFailed": "Esportazione dell'area del personale non riuscita.",
        "importFailed": "Importazione dell'area del personale non riuscita.",
        "personNotFound": "Persona non trovata per eseguire l'importazione. Contattare l'Amministratore.",
        "emailNotFound": "E-mail non trovata per eseguire l'importazione. Contattare l'Amministratore.",
        "importFalied": "Importazione dell'area del personale non riuscita."
      },
      "add": "Aggiungi Area del Personale",
      "delete": {
        "title": "Elimina Area del Personale",
        "text": "Sei sicuro di voler eliminare questa Area del Personale?"
      }
    },
    "position": {
      "menuName": "Posizione",
      "pageTitle": "Posizione",
      "id": "Id",
      "description": "Descrizione",
      "externalId": "Id Esterno",
      "active": "Attivo",
      "jobCode": "Lavoro",
      "jobId": "Lavoro",
      "organizationId": "Organizzazione",
      "employeeSubGroupId": "Sottogruppo di Dipendenti",
      "costCenterId": "Centro di Costo",
      "salaryLevelId": "Livello Salariale",
      "businessAreaId": "Area Aziendale",
      "bonusFrequencyId": "Frequenza del Bonus",
      "personnelAreaCode": "Area del Personale",
      "payGradeType": "Tipo di Grado Retributivo",
      "payGradeArea": "Area di Grado Retributivo",
      "employeeGroupId": "Gruppo di Dipendenti",
      "salaryGroupId": "Gruppo Salariale",
      "minimum": "Minimo",
      "midpoint": "Punto Intermedio",
      "edit": "Modifica Area Posizione",
      "messages": {
        "created": "Posizione creata con successo.",
        "updated": "Posizione aggiornata con successo.",
        "inUse": "Il record di posizione è in uso. Eliminare prima i suoi utilizzi.",
        "notFound": "Record di posizione non trovato"
      },
      "add": "Aggiungi Posizione"
    },
    "positionProfile": {
      "pageTitle": "Posizione Critica",
      "globalCritical": "Critico Globale",
      "countryCritical": "Critico per Paese",
      "businessUnitCritical": "Critico per Unità di Business",
      "positionType": "Tipo di Posizione",
      "sucessorType": "Tipo di Successore",
      "potentialSuccessorType": "Tipo di Successore",
      "potentialSuccessorId": "Successore Potenziale",
      "readinessFactor": "Fattore di Prontezza",
      "potentialSuccessorName": "Nome",
      "potentialSuccessorCompany": "Azienda",
      "potentialSuccessorLinkedIn": "URL LinkedIn",
      "potentialSuccessorNotes": "Note",
      "messages": {
        "created": "Posizione critica creata con successo.",
        "updated": "Posizione critica aggiornata con successo."
      }
    },
    "configuration": {
      "menuName": "Configurazione",
      "pageTitle": "Configurazione",
      "key": "Chiave",
      "value": "Valore",
      "editorType": "Tipo",
      "add": "Aggiungi Configurazione",
      "edit": "Modifica Configurazione",
      "delete": {
        "title": "Elimina Configurazione",
        "text": "Sei sicuro di voler eliminare questa configurazione?"
      },
      "messages": {
        "created": "Configurazione creata con successo.",
        "updated": "Configurazione aggiornata con successo.",
        "deleted": "Configurazione eliminata con successo."
      },
      "types": {
        "text": "Testo",
        "string": "Stringa",
        "number": "Numero",
        "int": "Intero",
        "boolean": "Booleano"
      }
    },
    "widget": {
      "menuName": "Widget",
      "pageTitle": "Widget",
      "name": "Nome",
      "description": "Descrizione",
      "securityResources": "Risorse di Sicurezza",
      "link": "Link",
      "query": "Query SQL",
      "queryRequired": "La query SQL è obbligatoria.",
      "sqlQueryDateFormatInfo": "Le colonne data devono essere formattate nel formato MM/dd/yyyy.",
      "minHeight": "Altezza Minima",
      "minWidth": "Larghezza Minima",
      "autoApplied": "Applica a tutte le dashboard",
      "autoAppliedHelp": "Questo forzerà questo widget su tutte le dashboard, e gli utenti continueranno a vederlo anche se provano a rimuoverlo.",
      "type": "Tipo",
      "category": "Categoria",
      "add": "Aggiungi Widget",
      "edit": "Modifica Widget",
      "delete": {
        "title": "Elimina Widget",
        "text": "Sei sicuro di voler eliminare questo widget?"
      },
      "examples": {
        "viewSQLExamples": "Visualizza esempi SQL",
        "general": "Generale",
        "generalDescription": "Per default, il sistema fornisce i seguenti parametri, che possono essere referenziati direttamente in qualsiasi query SQL widget.",
        "loggedUserNameDescription": "Username di login dell'utente attualmente connesso (ad esempio: {email}).",
        "loggedUserEmployeeIdDescription": "Identificativo dipendente dell'utente attualmente connesso.",
        "loggedUserLanguageDescription": "Codice lingua dell'utente attualmente connesso (ad esempio: en-US, pt-BR).",
        "loggedUserUniqueIdDescription": "Id univoco dell'utente (Guid)",
        "loggedUserEncryptedUniqueIdDescription": "Id univoco criptato dell'utente",
        "listDescription": "Ogni riga rappresenta un elemento della lista.",
        "numberDescription": "Restituisce un singolo valore numerico.",
        "donutDescription": "Le etichette e i valori devono essere allineati per posizione.",
        "lineDescription": "Ogni riga rappresenta una serie di linee."
      },
      "messages": {
        "created": "Widget creato con successo.",
        "updated": "Widget aggiornato con successo.",
        "deleted": "Widget eliminato con successo.",
        "fileRequired": "Il file è obbligatorio.",
        "importError": "Si è verificato un errore durante l'importazione del widget.",
        "queryVariablesMissing": "Le seguenti variabili sono assenti nella query del widget: \"{variables}\". Si prega di aggiungerle alla query per garantire il corretto funzionamento."
      }
    },
    "widgetCategory": {
      "menuName": "Categoria Widget",
      "pageTitle": "Categoria Widget",
      "name": "Nome",
      "description": "Descrizione",
      "type": "Tipo",
      "add": "Aggiungi Categoria Widget",
      "edit": "Modifica Categoria Widget",
      "delete": {
        "title": "Elimina Categoria Widget",
        "text": "Sei sicuro di voler eliminare questa categoria widget?"
      },
      "messages": {
        "created": "Categoria Widget creata con successo.",
        "updated": "Categoria Widget aggiornata con successo.",
        "deleted": "Categoria Widget eliminata con successo."
      }
    },
    "widgetType": {
      "menuName": "Tipo Widget",
      "pageTitle": "Tipo Widget",
      "name": "Nome",
      "types": {
        "number": "Numero",
        "list": "Lista",
        "donut": "Grafico ad anello",
        "line": "Linea"
      }
    },
    "widgetParameter": {
      "menuName": "Parametro Widget",
      "menuTitle": "Parametro Widget",
      "title": "Parametro Widget",
      "name": "Nome",
      "nameInfo": "Nome usato per identificare il parametro nella query SQL widget. Non usare spazi o caratteri speciali.",
      "nameUniqueError": "Un Parametro Widget con questo nome esiste già.",
      "description": "Descrizione",
      "isRequired": "È Obbligatorio?",
      "isMultiple": "È Multiplo?",
      "status": "Stato",
      "edit": "Modifica Parametro Widget",
      "add": "Aggiungi Parametro Widget",
      "type": "Tipo",
      "data": "Query SQL",
      "dataInfo": "La query SQL deve restituire due colonne chiamate 'Value' e 'Text'.",
      "listOfValues": "Lista di Valori",
      "addValue": "Aggiungi Valore",
      "value": "Valore",
      "label": "Etichetta",
      "delete": {
        "title": "Elimina Parametro Widget",
        "text": "Sei sicuro di voler eliminare {name}?"
      },
      "types": {
        "text": "Testo",
        "number": "Numero",
        "date": "Data",
        "boolean": "Booleano",
        "select": "Lista",
        "sql": "Lista Query"
      },
      "messages": {
        "notFound": "Parametro Widget non trovato.",
        "saveSuccess": "Parametro Widget salvato con successo.",
        "saveError": "Si è verificato un errore durante il salvataggio del Parametro Widget.",
        "deleteSuccess": "Parametro Widget eliminato con successo.",
        "deleteError": "Si è verificato un errore durante l'eliminazione del Parametro Widget.",
        "isInUse": "Impossibile eliminare il Parametro Widget perché è in uso."
      }
    },
    "people": {
      "menuName": "Persone",
      "pageTitle": "Persone",
      "edit": "Modifica Persona",
      "employeeId": "ID Dipendente",
      "person": "Persona",
      "id": "Id",
      "name": "Nome",
      "email": "E-mail",
      "externalId": "ID Esterno",
      "status": "Stato",
      "type": "Tipo",
      "positionShortDescription": "Breve descrizione della posizione",
      "hireDate": "Data di Assunzione",
      "culture": "Cultura",
      "sourceJTPInstance": "Codice JTP Sorgente",
      "documentId": "ID Documento",
      "manager": "Responsabile",
      "position": "Posizione",
      "bonusFrequency": "Frequenza Bonus",
      "businessArea": "Area Aziendale",
      "personnelArea": "Area del Personale",
      "division": "Divisione",
      "plant": "Stabilimento",
      "businessUnit": "Divisione aziendale",
      "shiftId": "Turno",
      "plantAreaId": "Area Stabilimento",
      "immigrationTypeId": "Tipo di Immigrazione",
      "customerSpecificStatus": "Stato Specifico Cliente",
      "vendorNumber": "Numero Fornitore",
      "accountNumber": "Ultime 4 Cifre del Conto",
      "overrideManagerId": "Responsabile Sostituto",
      "saipAllocation": "Allocazione SAIP",
      "requirePrivacyConsent": "Dipendente Globale",
      "globalDirectReports": "Riporti Diretti Globali",
      "globalManagerOverrideHelpText": "I dipendenti selezionati faranno riferimento a questo dipendente solo su scala globale. Se questo dipendente ha riporti diretti, tutti verranno contrassegnati come globali.",
      "messages": {
        "updated": "Persona aggiornata con successo.",
        "notFound": "Record della persona non trovato.",
        "alreadyExists": "Esiste già una persona con questa descrizione.",
        "fileRequired": "Il file è obbligatorio.",
        "importError": "Si è verificato un errore durante l'importazione delle persone.",
        "importSuccess": "Persone importate con successo. Riceverai il file via e-mail.",
        "importFailed": "Importazione delle persone non riuscita.",
        "personNotFound": "Persona non trovata per eseguire l'importazione. Contattare l'amministratore.",
        "emailNotFound": "E-mail non trovata per eseguire l'importazione. Contattare l'amministratore.",
        "importFalied": "Importazione delle persone fallita."
      },
      "personTypes": {
        "unknown": "Sconosciuto",
        "salariedEmployee": "Dipendente Stipendiato",
        "contractor": "Contrattista",
        "vendor": "Fornitore",
        "hourlyEmployee": "Dipendente Orario",
        "external": "Esterno",
        "duHourlyInactive": "DU Orario Inattivo",
        "duSalariedInactive": "DU Stipendiato Inattivo",
        "duTruckDriverIn": "DU Camionista Dentro",
        "executive": "Dirigente",
        "union": "Sindacalizzato",
        "nonUnion": "Non Sindacalizzato",
        "unionPossible": "Sindacalizzazione Possibile",
        "salariedNonExempt": "Stipendiato Non Esente",
        "hourly": "Orario",
        "duPaidLeave": "DU Congedo Retribuito",
        "truckDriver": "Camionista",
        "duUnpaidLeave": "DU Congedo Non Retribuito",
        "workRelease": "Rilascio Lavorativo",
        "externalAccessLevelOne": "Accesso Esterno Livello Uno",
        "externalAccessLevelTwo": "Accesso Esterno Livello Due",
        "externalAccessLevelThree": "Accesso Esterno Livello Tre",
        "externalAccessLevelFour": "Accesso Esterno Livello Quattro",
        "externalAccessLevelFive": "Accesso Esterno Livello Cinque",
        "globalEmployee": "Dipendente Globale"
      },
      "customerSpecificStatuses": {
        "unknown": "Sconosciuto",
        "active": "Attivo",
        "inactive": "Inattivo",
        "incomeAssistance": "Assistenza al reddito",
        "lOA": "LOA",
        "retiree": "Pensionato",
        "withdrawn": "Ritirato"
      }
    },
    "reportColumnTemplate": {
      "menuName": "Modelli di Colonna Report",
      "pageTitle": "Modelli di Colonna Report",
      "id": "ID",
      "description": "Descrizione",
      "template": "Modello",
      "templateHelp": "Usa {value} come segnaposto per il valore della cella. HTML è supportato.",
      "add": "Aggiungi Modello",
      "edit": "Modifica Modello",
      "delete": {
        "title": "Elimina Modello",
        "text": "Sei sicuro di voler eliminare \"{name}\"?"
      },
      "messages": {
        "created": "Modello creato con successo.",
        "updated": "Modello aggiornato con successo.",
        "deleted": "Modello eliminato con successo."
      }
    },
    "companyCode": {
      "menuName": "Codici Azienda"
    },
    "costCenter": {
      "menuName": "Centri di Costo"
    },
    "currency": {
      "menuName": "Valute"
    },
    "exchangeRate": {
      "menuName": "Tassi di Cambio"
    }
  },
  "threeHundredSixty": {
    "menuTitle": "360",
    "questionOption": {
      "menuTitle": "Scale di Valutazione",
      "pageTitle": "Scale di Valutazione",
      "description": "Descrizione",
      "add": "Aggiungi Scala di Valutazione",
      "edit": "Modifica Scala di Valutazione",
      "delete": {
        "title": "Elimina Scala di Valutazione",
        "text": "Sei sicuro di voler eliminare questa scala di valutazione?"
      },
      "messages": {
        "notFound": "Scala di valutazione non trovata.",
        "saveSuccess": "Scala di valutazione salvata con successo.",
        "saveError": "Si è verificato un errore durante il salvataggio della Scala di Valutazione.",
        "deleteSuccess": "Scala di valutazione eliminata con successo.",
        "deleteError": "Si è verificato un errore durante l'eliminazione della Scala di Valutazione.",
        "isInUse": "Impossibile eliminare la Scala di Valutazione perché è in uso.",
        "duplicateName": "Esiste già una Scala di Valutazione con questa descrizione."
      },
      "options": {
        "title": "Opzioni",
        "value": "Valore",
        "description": "Descrizione",
        "explanation": "Spiegazione",
        "itemOrder": "Ordine",
        "color": "Colore",
        "commentConfig": "Configurazione Commenti",
        "add": "Aggiungi Opzione",
        "edit": "Modifica Opzione",
        "delete": {
          "title": "Elimina Opzione",
          "text": "Sei sicuro di voler eliminare questa opzione?"
        },
        "messages": {
          "created": "Opzione creata con successo.",
          "updated": "Opzione aggiornata con successo.",
          "deleted": "Opzione eliminata con successo.",
          "notFound": "Opzione non trovata.",
          "duplicateValue": "Due o più opzioni hanno lo stesso valore. Ogni opzione deve avere un valore univoco.",
          "duplicateDescription": "Due o più opzioni hanno la stessa descrizione. Ogni opzione deve avere una descrizione univoca."
        },
        "commentConfigType": {
          "followForm": "Segui Modulo",
          "required": "Obbligatorio",
          "notRequired": "Non Obbligatorio"
        }
      }
    },
    "questionGroup": {
      "menuTitle": "Gruppi di Domande",
      "pageTitle": "Gruppi di Domande",
      "name": "Nome",
      "description": "Descrizione",
      "add": "Aggiungi Gruppo di Domande",
      "edit": "Modifica Gruppo di Domande",
      "delete": {
        "title": "Elimina Gruppo di Domande",
        "text": "Sei sicuro di voler eliminare questo gruppo di domande: {name}?"
      },
      "messages": {
        "notFound": "Gruppo di domande non trovato.",
        "saveSuccess": "Gruppo di domande salvato con successo.",
        "saveError": "Si è verificato un errore durante il salvataggio del Gruppo di Domande.",
        "deleteSuccess": "Gruppo di domande eliminato con successo.",
        "deleteError": "Si è verificato un errore durante l'eliminazione del Gruppo di Domande.",
        "isInUse": "Impossibile eliminare il Gruppo di Domande perché è in uso."
      }
    },
    "question": {
      "menuTitle": "Domande",
      "pageTitle": "Domande",
      "name": "Nome",
      "weight": "Peso",
      "commentDisabled": "Commento Disabilitato",
      "description": "Descrizione",
      "questionGroup": "Gruppo di Domande",
      "questionOption": "Scala di Valutazione",
      "add": "Aggiungi Domanda",
      "edit": "Modifica Domanda",
      "delete": {
        "title": "Elimina Domanda",
        "text": "Sei sicuro di voler eliminare questa domanda?"
      },
      "messages": {
        "notFound": "Domanda non trovata.",
        "saveSuccess": "Domanda salvata con successo.",
        "saveError": "Si è verificato un errore durante il salvataggio della Domanda.",
        "deleteSuccess": "Domanda eliminata con successo.",
        "deleteError": "Si è verificato un errore durante l'eliminazione della Domanda.",
        "isInUse": "Impossibile eliminare la Domanda perché è in uso."
      }
    },
    "formCategory": {
      "menuTitle": "Categorie Modulo",
      "pageTitle": "Categorie Modulo",
      "name": "Nome",
      "description": "Descrizione",
      "add": "Aggiungi Categoria Modulo",
      "edit": "Modifica Categoria Modulo",
      "delete": {
        "title": "Elimina Categoria Modulo",
        "text": "Sei sicuro di voler eliminare questa categoria modulo?"
      },
      "messages": {
        "notFound": "Categoria modulo non trovata.",
        "saveSuccess": "Categoria modulo salvata con successo.",
        "saveError": "Si è verificato un errore durante il salvataggio della Categoria Modulo.",
        "deleteSuccess": "Categoria modulo eliminata con successo.",
        "deleteError": "Si è verificato un errore durante l'eliminazione della Categoria Modulo.",
        "isInUse": "Impossibile eliminare la Categoria Modulo perché è in uso."
      }
    },
    "formDelegate": {
      "menuTitle": "Delegato di Modulo",
      "pageTitle": "Delegato di Modulo",
      "form": "Modulo",
      "manager": "Manager",
      "delegate": "Delegato",
      "add": "Aggiungi Delegato di Modulo",
      "edit": "Modifica Delegato di Modulo",
      "delegatedToPerson": "Delega a",
      "invitedEnabled": "Invito Abilitato",
      "signEnabled": "Firma Abilitata",
      "resultViewerEnabled": "Visualizzatore Risultati Abilitato",
      "delete": {
        "title": "Elimina Delegato di Modulo",
        "text": "Sei sicuro di voler eliminare questo delegato di modulo?"
      },
      "messages": {
        "notFound": "Delegato di Modulo non trovato.",
        "saveSuccess": "Delegato di Modulo salvato con successo.",
        "saveError": "Si è verificato un errore durante il salvataggio del Delegato di Modulo.",
        "deleteSuccess": "Delegato di Modulo eliminato con successo.",
        "deleteError": "Si è verificato un errore durante l'eliminazione del Delegato di Modulo.",
        "managerDisabledMessage": "Non hai accesso a questo modulo delegato"
      }
    },
    "formDelegateGlobal": {
      "menuTitle": "Delegato di Modulo Globale",
      "pageTitle": "Delegato di Modulo Globale"
    },
    "form": {
      "menuTitle": "Moduli",
      "pageTitle": "Moduli",
      "id": "Id",
      "description": "Descrizione",
      "category": "Categoria",
      "categoryId": "Categoria",
      "stage": {
        "label": "Fase",
        "preparation": "Preparazione",
        "execution": "Esecuzione",
        "managerReview": "Revisione del Manager",
        "participantReview": "Revisione del Partecipante",
        "closed": "Chiuso"
      },
      "active": "Attivo",
      "maximumHireDate": "Data massima di assunzione",
      "maxPeopleEvaluateAlert": "Avviso massimo di valutazioni",
      "includeGlobalReporting": "Report globali",
      "customerSpecificStatus": "Stato specifico del cliente",
      "employeeType": "Tipo di dipendente",
      "reportType": {
        "label": "Tipo di rapporto",
        "question": "Per Domanda",
        "questionGroup": "Per Gruppo di domande"
      },
      "directReportBox": "Valutazione di subordinato",
      "selfEvaluationBox": "Autovalutazione",
      "managerEvaluationBox": "Valutazione del manager",
      "crossGroupEvaluationBox": "Valutazione tra gruppi incrociati",
      "freeEvaluationBox": "Valutazione libera",
      "dueDatesBox": "Scadenza",
      "evaluation": "Valutazione",
      "comments": "Commenti",
      "weight": "Peso",
      "minCrossGroupEvaluations": "Minimo di valutazioni di gruppo incrociato",
      "crossGroupDueDate": "Crea Cross Group – Sé",
      "evaluationDueDate": "Crea Cross Group – Manager",
      "managerSignDueDate": "Final Cross Group – Manager",
      "participantSignDueDate": "Data di Chiusura",
      "processDueDate": "Valutazione",
      "beginningReviewDate": "Revisione del periodo di prova",
      "endingReviewDate": "Fine del Periodo di Revisione",
      "maxReleaseQuestionnaireDate": "Rilasciare Questionario",
      "createdBy": "Creato da",
      "createdDate": "Data di creazione",
      "modifiedBy": "Modificato da",
      "modifiedDate": "Data di modifica",
      "maximumHireDateHelpText": "Data massima di assunzione dell'impiegato per partecipare, a meno che l'impiegato non sia un dirigente.",
      "maxPeopleEvaluateAlertHelpText": "Mostra un avviso dopo che l'impiegato raggiunge il numero massimo di persone da valutare.",
      "includeGlobalReportingHelpText": "Includere nei report globali",
      "directReportEvaluationHelpText": "Valutazione collaboratori diretti",
      "directReportCommentsHelpText": "Commenti collaboratori diretti",
      "directReportWeightHelpText": "Peso collaboratore diretto",
      "selfEvaluationHelpText": "Autovalutazione",
      "selfCommentsHelpText": "Commenti personali",
      "selfWeightHelpText": "Peso proprio",
      "managerEvaluationHelpText": "Valutazione del manager",
      "managerCommentsHelpText": "Commenti del manager",
      "managerWeightHelpText": "Peso del manager",
      "freeCommentsHelpText": "Commenti liberi",
      "freeWeightHelpText": "Peso libero",
      "crossGroupEvaluationHelpText": "Valutazione di tutti i gruppi",
      "crossGroupCommentsHelpText": "Commenti di tutti i gruppi",
      "crossGroupWeightHelpText": "Peso di tutti i gruppi",
      "minCrossGroupEvaluationsHelpText": "Numero minimo di valutazioni di tutti i gruppi per consentire al manager di rilasciare il questionario.",
      "maxReleaseQuestionnaireDateHelpText": "Data massima per il manager per rilasciare il questionario",
      "add": "Aggiungi Modulo",
      "edit": "Modifica Modulo",
      "updateCounters": "Aggiorna Contatori",
      "detailedResult": "Risultato dettagliato",
      "move": {
        "button": "Sposta a {stage}",
        "title": "Sposta fase",
        "text": "Sei sicuro di voler spostare questo modulo alla fase {stage}?"
      },
      "duplicate": {
        "button": "Duplica",
        "title": "Duplica Modulo",
        "text": "Sei sicuro di voler duplicare questo modulo?"
      },
      "delete": {
        "title": "Elimina Modulo",
        "text": "Sei sicuro di voler eliminare questo modulo: {name}?"
      },
      "formQuestion": {
        "title": "Domande del Modulo",
        "question": "Domanda",
        "itemOrder": "Ordine",
        "questionGroup": "Gruppo di domande",
        "add": "Aggiungi Domanda",
        "edit": "Modifica Domanda",
        "delete": {
          "title": "Elimina Domanda",
          "text": "Sei sicuro di voler eliminare {name} da questo modulo?"
        },
        "messages": {
          "saveSuccess": "Domanda del modulo salvata con successo.",
          "saveError": "Si è verificato un errore durante il salvataggio della Domanda del Modulo.",
          "deleteSuccess": "Domanda del modulo eliminata con successo.",
          "deleteError": "Si è verificato un errore durante l'eliminazione della Domanda del Modulo.",
          "duplicateQuestion": "Questa domanda è già stata aggiunta al modulo.",
          "notFound": "Domanda del Modulo non trovata.",
          "questionNotFound": "Domanda non trovata."
        }
      },
      "messages": {
        "notFound": "Modulo non trovato.",
        "saveSuccess": "Modulo salvato con successo.",
        "saveError": "Si è verificato un errore durante il salvataggio del Modulo.",
        "deleteSuccess": "Modulo eliminato con successo.",
        "deleteError": "Si è verificato un errore durante l'eliminazione del Modulo.",
        "deleteNotAllowed": "Impossibile eliminare un modulo che non è nella fase di Preparazione.",
        "isInUse": "Impossibile eliminare il Modulo perché è in uso.",
        "atLeastOneMemberEvaluate": "Almeno uno di questi gruppi di campi deve essere attivo: Valutazione del Segnalato Diretto, Autovalutazione, Valutazione Incrociata di Gruppo o Valutazione del Manager.",
        "maximumHireDateRequired": "La data massima di assunzione è obbligatoria.",
        "dueDatesRequired": "Tutte le scadenze sono obbligatorie.",
        "moveStageSuccess": "Modulo spostato alla fase successiva con successo.",
        "moveStageNotAllowed": "Impossibile spostare un modulo chiuso a un'altra fase.",
        "moveStageNotAllowedNoPeople": "Il modulo non ha persone. Per spostarsi, visita la pagina Persone del Modulo per includere persone in questo modulo.",
        "moveStageNotAllowedNoQuestions": "Il modulo non contiene domande. Per spostarlo, inserisci almeno una domanda.",
        "duplicateSuccess": "Modulo duplicato con successo.",
        "updateCountersSuccess": "L'aggiornamento dei contatori è stato avviato.",
        "detailedResultSuccess": "La generazione del risultato dettagliato è stata avviata."
      }
    },
    "formEmailSender": {
      "menuTitle": "Modulo Mittente Email",
      "pageTitle": "Modulo Mittente Email",
      "messages": {
        "emailsSent": "Email inviate con successo."
      }
    },
    "questionnaire": {
      "questionnaireTypes": {
        "manager": "Manager",
        "directReport": "Subordinato diretto",
        "crossGroup": "Cross Group",
        "selfEvaluation": "Autovalutazione",
        "freeEvaluation": "Valutazione libera"
      },
      "questionnaireRequestTypes": {
        "default": "Predefinito",
        "manager": "Manager",
        "directReport": "Dipendente"
      },
      "questionnaireStatus": {
        "done": "Completato",
        "declined": "Rifiutato",
        "open": "Aperto"
      },
      "questionnairePriorityTypes": {
        "selfDirectManager": "Self, Directs & Manager",
        "crossGroupPeers": "Intergroupe (Pairs)",
        "crossGroup": "Intergroupe",
        "freeEvaluation": "Valutazione libera"
      },
      "questionnairesReport": {
        "title": "Rapporto dei Questionari",
        "messages": {
          "confirm": "Il file sarà esportato. Riceverai i risultati via email a breve.",
          "success": "L'esportazione del rapporto dei questionari è stata avviata. Riceverai i risultati via email a breve.",
          "emailNotFound": "Email non trovata per effettuare l'esportazione. Contatta l'amministratore.",
          "formNotFound": "Modulo non trovato per effettuare l'esportazione. Contatta l'amministratore.",
          "exportFailed": "Esportazione del rapporto dei questionari fallita."
        }
      },
      "createCrossGroupForMyself": {
        "menuTitle": "Creare un gruppo incrociato per me stesso",
        "pageTitle": "Creare un gruppo incrociato per me stesso",
        "form": "Modulo",
        "infoMessage": " Di seguito è riportato il tuo cross group predefinito. Aggiungi ulteriori dipendenti da cui vorresti essere valutato. Devi averne almeno cinque etichettati come tipo \"cross group\". Il tuo manager esaminerà, aggiornerà di conseguenza e rilascerà i questionari.",
        "warningReleasedQuestionnaires": "Non sei in grado di aggiungere gruppi incrociati perché il tuo responsabile ha già rilasciato dei questionari su di te. Per favore, parla con lui riguardo l'aggiunta di ulteriori questionari.",
        "add": "Aggiungi Dipendente",
        "evaluatorPerson": "Valutatore",
        "manager": "Manager",
        "type": "Tipo",
        "requestType": "Richiesto da",
        "released": "Rilasciato",
        "status": "Stato",
        "actions": "Azioni",
        "delete": {
          "title": "Elimina il questionario",
          "text": "Sei sicuro di voler eliminare questo questionario?"
        },
        "messages": {
          "alreadyExists": "Questo questionario esiste già per {names}. In caso di domande, parla con il tuo manager.",
          "addSuccess": "Questionari creati con successo.",
          "deleteSuccess": "Questionario eliminato con successo.",
          "invitedPersonWarning": "{names} è già stato invitato a fornire feedback 360 su almeno {limit} altri moduli. Per includerli in moduli aggiuntivi, seleziona «Salva». Se il loro feedback non è essenziale, chiudi senza salvare e seleziona un'altra persona."
        }
      },
      "crossGroupForMyTeam": {
        "menuTitle": "Crea Gruppi Trasversali per il Mio Team",
        "pageTitle": "Crea Gruppi Trasversali per il Mio Team",
        "form": "Modulo",
        "manager": "Manager",
        "evaluatedPerson": "Valutato",
        "evaluatorPerson": "Valutatore",
        "type": "Tipo",
        "released": "Rilasciato",
        "status": "Stato",
        "loadCrossGroupDefaults": "Carica Impostazioni Predefinite Gruppi Trasversali",
        "unloadCrossGroupDefaults": "Scarica Impostazioni Predefinite Gruppi Trasversali",
        "releaseQuestionnaire": "Rilascia Questionari",
        "add": "Aggiungi Questionario",
        "delete": {
          "title": "Elimina Questionario",
          "text": "Sei sicuro di voler eliminare questo questionario?"
        },
        "messages": {
          "createdSuccess": "Questionari creati con successo.",
          "deletedSuccess": "Questionario eliminato con successo.",
          "saveError": "Si è verificato un errore durante il salvataggio del questionario. Riprova.",
          "questionnairesAlreadyExists": "I questionari esistono già per: {names}.",
          "managerDisabledMessage": "Non hai accesso a questo modulo di gruppo trasversale",
          "releasedSuccess": "Questionari rilasciati con successo.",
          "minCrossGroupEvaluations": "Vengono visualizzate solo le persone con almeno {value} questionari di gruppo trasversale.",
          "noQuestionnairesToRelease": "Non ci sono questionari da rilasciare. Aggiungi almeno un questionario da rilasciare.",
          "isReadOnlyDueStage": "Questo modulo è di sola lettura e non può essere modificato",
          "remoteInstanceWarning": "Si è verificato un problema durante il caricamento delle informazioni remote.",
          "alreadyExists": "Questo questionario esiste già per {names}. Se hai domande, parla con il tuo manager.",
          "minimumCrossGroupsNotMet": "Il dipendente non ha il numero minimo di gruppi trasversali ({current}/{minimum})",
          "questionnairesReleased": "Questionari rilasciati",
          "readyForRelease": "Pronto per il rilascio"
        },
        "crossGroupDefaults": {
          "loadDefaults": {
            "title": "Carica Impostazioni Predefinite Gruppi Trasversali",
            "messages": {
              "confirm": "AVVISO: Conferma che desideri caricare i partecipanti ai gruppi trasversali predefiniti per tutti i tuoi diretti.",
              "success": "Partecipanti ai gruppi trasversali predefiniti caricati con successo."
            }
          },
          "unloadDefaults": {
            "title": "Scarica Impostazioni Predefinite Gruppi Trasversali",
            "messages": {
              "confirm": "Conferma che desideri scaricare i partecipanti ai gruppi trasversali predefiniti per tutti i tuoi diretti.",
              "success": "Partecipanti ai gruppi trasversali predefiniti scaricati con successo."
            }
          }
        }
      },
      "crossGroupForMyRemoteTeam": {
        "menuTitle": "Crea Gruppi Trasversali per il Mio Team Remoto",
        "pageTitle": "Crea Gruppi Trasversali per il Mio Team Remoto"
      },
      "complete": {
        "menuTitle": "Completa il Questionario",
        "pageTitle": "Completa il Questionario",
        "form": "Modulo",
        "questionnaireType": "Tipo di Questionario",
        "submit": "Invia",
        "notApplicable": "N/A",
        "declinedCommentPlaceholder": "Non Applicabile",
        "reopen": "Riapri",
        "status": {
          "new": "Questionario non avviato",
          "inProgress": "Questionario in corso",
          "completed": "Questionario completato"
        },
        "notApplicableTitle": "Rifiuta il questionario",
        "reopenTitle": "Conferma il ritiro",
        "addFreeEvaluation": "Aggiungi Valutazione Libera",
        "personToEvaluate": "Persona da Valutare",
        "freeEvaluationWarning": "Le Valutazioni Libere dovranno essere approvate dai manager e non contribuiscono ai punteggi complessivi del 360.",
        "messages": {
          "loading": "Caricamento questionari...",
          "loadingGlobalQuestionnaires": "Caricamento questionari globali...",
          "formNotFound": "Modulo non trovato.",
          "employeeNotFound": "Dipendente non trovato.",
          "freeEvaluationNotAllowed": "Non puoi aggiungere una valutazione libera per te stesso, il tuo manager, i tuoi colleghi o i tuoi subordinati diretti.",
          "alreadyExists": "Esiste già una valutazione per questa persona.",
          "submitConfirmation": "Facendo clic su invia, la valutazione del dipendente visualizzato è ciò che verrà registrato. È possibile ritirare le valutazioni inviate fino a quando il processo 360 non passa alla firma del manager.",
          "summaryValidate": "Convalida le risposte e scorri verso il basso per inviare. Fare clic sulla X in alto a destra non finalizzerà il tuo invio.",
          "submitSuccess": "Questionario inviato con successo.",
          "questionnaireNotFound": "Questionario non trovato.",
          "notSubmittedWarningMessage": "Questo questionario non è ancora stato inviato e non viene considerato nel punteggio del dipendente.",
          "noQuestionnaires": "Non hai questionari da completare.",
          "selectQuestionnaire": "Seleziona un questionario da completare.",
          "employeeRateSummary": "Valutazione del Dipendente: ",
          "notApplicable": "Se non sei la persona appropriata per completare questa valutazione delle prestazioni, puoi declinare la responsabilità, dopo aver fornito un motivo.",
          "declineSuccess": "Questionario rifiutato con successo.",
          "requiredQuestionnairesCompleted": "Tutte le valutazioni rimanenti possono essere completate a tua discrezione.",
          "allQuestionsRequired": "Tutte le domande e i commenti sono obbligatori per poter inviare.",
          "confirmReopen": "Sei sicuro di voler ritirare la valutazione per {name}?",
          "reopenSuccess": "Questionario riaperto con successo.",
          "questionnaireAlreadySubmitted": "Questo questionario è già stato inviato e non può essere modificato.",
          "addFreeEvaluationSuccess": "Valutazione libera aggiunta con successo."
        }
      },
      "freeEvaluation": {
        "menuTitle": "Crea valutazione libera",
        "menuTitleGlobal": "Crea valutazione libera (Globale)",
        "pageTitle": "Crea valutazione libera",
        "pageTitleGlobal": "Crea valutazione libera (Globale)",
        "evaluatedPerson": "Valutato",
        "view": "Visualizza",
        "infoMessage": "Esamina le valutazioni qui sotto e approva quelle con cui sei d'accordo. Se non approvi una valutazione, non è richiesta alcuna ulteriore azione.",
        "messages": {
          "approvalSuccess": "Valutazione approvata con successo.",
          "confirmApproval": "Sei sicuro di voler approvare il questionario?",
          "notFound": "Valutazione non trovata."
        }
      }
    },
    "formPeople": {
      "participants": {
        "menuTitle": "Partecipanti al modulo",
        "pageTitle": "Partecipanti al modulo",
        "formId": "Modulo",
        "resetTree": "Reimposta albero",
        "resetTreeTitle": "Reimposta albero",
        "resetTreeText": "Sei sicuro di voler reimpostare l'albero?",
        "addPerson": "Aggiungi partecipante",
        "changeManager": "Cambia responsabile",
        "downloadTemplate": "Scarica modello",
        "import": "Importa",
        "person": "Dipendente",
        "currentManager": "Responsabile attuale",
        "newManager": "Nuovo responsabile",
        "messages": {
          "noNodeSelected": "Devi selezionare almeno un dipendente.",
          "saveSuccess": "Partecipanti del modulo salvati con successo.",
          "resetSuccess": "Partecipanti del modulo reimpostati con successo.",
          "formNotFound": "Modulo non trovato.",
          "selectEmployee": "Seleziona prima un dipendente",
          "addPersonSuccess": "Partecipante aggiunto con successo.",
          "changeManagerSuccess": "Responsabile cambiato con successo.",
          "moveToManagerSuccess": "Persona spostata al nuovo responsabile con successo.",
          "managerNotInTree": "Il responsabile selezionato non è nell'albero.",
          "circularManagerSelection": "Impossibile spostare un dipendente verso un proprio subordinato.",
          "importSuccess": "File importato con successo. Riceverai presto i risultati via e-mail."
        },
        "errors": {
          "formInExecution": "Questa azione non puo essere eseguita perche il modulo e attualmente in esecuzione."
        }
      },
      "resultViewer": {
        "menuTitle": "Report PDF approvati",
        "pageTitle": "Report PDF approvati",
        "person": "Persona",
        "personHelpText": "Puoi selezionare te stesso o uno qualsiasi dei tuoi riporti diretti.",
        "personMultipleInstance": "Non selezionare dipendenti da più istanze. I risultati potrebbero essere errati o incompleti.",
        "manager": "Responsabile",
        "form": "Modulo",
        "position": "Posizione",
        "managerFeedback": "Feedback del responsabile",
        "employeeFeedback": "Feedback del dipendente",
        "pdfReport": "Report PDF",
        "pdfReportFreeEvaluation": "PDF valutazione libera",
        "pdfReportFreeEvaluationNonApproved": "PDF valutazione libera non approvata",
        "downloadSelected360Report": "Scarica report 360 selezionato",
        "downloadSelectedFreeEvaluationReport": "Scarica report valutazione libera selezionato",
        "downloadSelectedNonApprovedFreeEvaluationReport": "Scarica report valutazione libera non approvata selezionato",
        "emailSelected360Report": "Invia via e-mail report 360 selezionato",
        "emailSelectedFreeEvaluationReport": "Invia via e-mail report valutazione libera selezionato",
        "emailSelectedNonApprovedFreeEvaluationReport": "Invia via e-mail report valutazione libera non approvata selezionato",
        "bulkEmailQueued": "I tuoi report sono in preparazione. Riceverai a breve un'e-mail con gli allegati PDF.",
        "bulkEmailNoSelection": "Seleziona almeno una riga.",
        "bulkEmailInvalidSelection": "Una o più righe selezionate non sono valide per il tuo accesso.",
        "bulkEmailNoReportForKind": "Le righe selezionate non includono questo tipo di report.",
        "showFeedback": "Mostra feedback",
        "downloadEvaluationSelectOne": "Seleziona una persona o un responsabile.",
        "validationSelectPersonOrManager": "Seleziona una persona o un responsabile per eseguire il filtro.",
        "successPdfByEmail": "Il PDF è stato inviato con successo alla tua e-mail."
      },
      "sign": {
        "menuTitle": "Firma",
        "menuTitleGlobal": "Firma (Globale)",
        "pageTitle": "Firma",
        "pageTitleGlobal": "Firma (Globale)",
        "form": "Modulo",
        "person": "Persona",
        "managerOrPerson": "Manager o Persona",
        "managerSign": "Firma Manager",
        "personSign": "Firma del dipendente",
        "sign": "Firma",
        "signTitle": "Titolo Firma",
        "signatureComments": "Commenti Firma",
        "signed": "Firmato",
        "updateComment": "Aggiorna Commento",
        "pdfReport": "Report PDF",
        "pdfReportFreeEvaluation": "Report PDF Valutazione Libera",
        "messages": {
          "employeeSignatureNotAllowed": "La firma del dipendente non è consentita.",
          "managerSignatureNotAllowed": "La firma del manager non è consentita.",
          "noComments": "Nessun commento disponibile.",
          "signConfirmationManager": "Sei sicuro di voler firmare come manager?",
          "signConfirmationPerson": "Sei sicuro di voler firmare come persona?",
          "signConfirmationWarning": "Una volta firmato, non potrai più modificare questo modulo.",
          "signedBy": "Firmato da {name} il {date}",
          "successMessage": "Firma completata con successo.",
          "updateCommentSuccessMessage": "Commento aggiornato con successo."
        }
      }
    }
  },
  "security": {
    "menuTitle": "Sicurezza",
    "resource": {
      "menuName": "Risorsa",
      "pageTitle": "Risorsa",
      "add": "Aggiungi risorsa",
      "edit": "Modifica risorsa",
      "delete": {
        "title": "Elimina risorsa",
        "text": "Sei sicuro di voler eliminare questa risorsa?"
      },
      "id": "Id",
      "name": "Nome",
      "description": "Descrizione",
      "resourceType": "Tipo di risorsa",
      "isActive": "Attivo",
      "messages": {
        "created": "Risorsa creata con successo.",
        "updated": "Risorsa aggiornata con successo.",
        "deleted": "Risorsa eliminata con successo.",
        "notFound": "Risorsa non trovata",
        "duplicateName": "Esiste già una risorsa con questo nome.",
        "inUse": "La risorsa è in uso. Elimina prima gli utilizzi."
      }
    },
    "user": {
      "menuName": "Utente",
      "pageTitle": "Utente",
      "subgridName": "Account utente",
      "uniqueId": "Id univoco",
      "add": "Aggiungi account utente",
      "edit": "Modifica account utente",
      "delete": {
        "title": "Elimina account utente",
        "text": "Sei sicuro di voler eliminare questo account?"
      },
      "personId": "Id",
      "provider": "Provider",
      "userName": "Nome utente",
      "isActive": "Attivo",
      "messages": {
        "created": "Account utente creato con successo.",
        "updated": "Account utente aggiornato con successo.",
        "deleted": "Account utente eliminato con successo.",
        "notFound": "Account non trovato",
        "duplicateName": "Questo nome utente esiste già."
      }
    },
    "group": {
      "menuName": "Gruppo",
      "pageTitle": "Gruppo",
      "add": "Aggiungi gruppo",
      "edit": "Modifica gruppo",
      "delete": {
        "title": "Elimina gruppo?",
        "text": "Sei sicuro di voler eliminare questo gruppo?"
      },
      "id": "Id",
      "name": "Nome",
      "description": "Descrizione",
      "isActive": "Attivo",
      "overwriteGroups": "Sovrascrivi gruppi",
      "messages": {
        "created": "Gruppo creato con successo.",
        "updated": "Gruppo aggiornato con successo.",
        "deleted": "Gruppo eliminato con successo.",
        "notFound": "Gruppo non trovato",
        "duplicateName": "Esiste già un gruppo con questo nome.",
        "fileRequired": "Il file è obbligatorio.",
        "imported": "I gruppi sono stati importati correttamente"
      }
    },
    "groupPeople": {
      "menuName": "Persone del gruppo",
      "pageTitle": "Persone del gruppo",
      "add": "Aggiungi persone al gruppo",
      "edit": "Modifica persone del gruppo",
      "delete": {
        "title": "Elimina persone del gruppo",
        "text": "Sei sicuro di voler eliminare questo record?"
      },
      "groupId": "Gruppo",
      "personId": "Persona",
      "validityStart": "Inizio validità",
      "validityEnd": "Fine validità",
      "messages": {
        "created": "Persona del gruppo creata con successo.",
        "updated": "Persona del gruppo aggiornata con successo.",
        "deleted": "Persona del gruppo eliminata con successo.",
        "notFound": "Record non trovato",
        "alreadyExists": "L'utente usa già questo gruppo."
      }
    },
    "groupPermission": {
      "menuName": "Permessi di gruppo",
      "pageTitle": "Permessi di gruppo",
      "add": "Aggiungi permesso",
      "edit": "Modifica permesso",
      "delete": {
        "title": "Elimina permesso",
        "text": "Sei sicuro di voler eliminare questo permesso?"
      },
      "groupId": "Gruppo",
      "resourceId": "Risorsa",
      "action": "Azione",
      "messages": {
        "created": "Permesso creato con successo.",
        "updated": "Permesso aggiornato con successo.",
        "deleted": "Permesso eliminato con successo.",
        "notFound": "Record non trovato",
        "duplicateName": "Permesso già esistente per questa risorsa."
      }
    }
  },
  "goals": {
    "menuName": "Obiettivi",
    "kpi": {
      "menuName": "KPI"
    },
    "plan": {
      "menuName": "Piani"
    },
    "target": {
      "menuName": "Obiettivi",
      "kpiOwner": {
        "menuName": "Obiettivi - Proprietario KPI"
      }
    },
    "actual": {
      "menuName": "Dati effettivi",
      "kpiOwner": {
        "menuName": "Dati effettivi - Proprietario KPI"
      }
    },
    "discussionNotes": {
      "menuName": "Note di Discussione"
    },
    "flexibleGoal": {
      "menuName": "Obiettivo Flessibile"
    },
    "actionPlan": {
      "menuName": "Piano d'Azione"
    },
    "library": {
      "menuName": "Biblioteca"
    },
    "category": {
      "menuName": "Categoria"
    },
    "PlantArea": {
      "menuName": "Area Impianto"
    },
    "clerks": {
      "menuName": "Proprietari dei KPI"
    },
    "quickEntry": {
      "menuName": "Inserimento Rapido Annuale"
    }
  },
  "nineBox": {
    "menuName": "9box",
    "nineBoxForm": {
      "menuName": "Modulo"
    },
    "nineBoxFormPeople": {
      "menuName": "Partecipanti al Modulo"
    },
    "fillTalentTalk": {
      "menuName": "Guida Talent Talk"
    },
    "nineBoxCalibration": {
      "menuName": "Calibrazione"
    },
    "fillDevelopmentPlan": {
      "menuName": "PDI"
    }
  },
  "pcf": {
    "menuName": "PCF",
    "dashboard": {
      "menuName": "Pannello"
    },
    "request": {
      "newPCF": {
        "menuName": "Nuovo PCF"
      }
    },
    "requestType": {
      "menuName": "Tipo di Richiesta"
    },
    "approvalGroup": {
      "menuName": "Gruppo di Approvazione"
    },
    "requestStatuses": {
      "menuName": "Stato della Richiesta"
    },
    "catalog": {
      "menuName": "Catalogo"
    },
    "immigrationType": {
      "menuName": "Tipo di Immigrazione"
    }
  },
  "merit": {
    "menuName": "Merito",
    "meritPlanFormList": {
      "menuName": "Elenco Moduli"
    },
    "meritDashboard": {
      "menuName": "Pannello"
    },
    "meritPlan": {
      "menuName": "Piano"
    },
    "awardLetter": {
      "menuName": "Lettera di Premio"
    },
    "meritPlanParticipants": {
      "menuName": "Partecipanti Piano Merito"
    }
  },
  "bonus": {
    "menuName": "Bonus",
    "bonusIncentiveGroup": {
      "menuName": "Gruppo Incentivo"
    },
    "bonusPlan": {
      "menuName": "Piano"
    },
    "bonusPlanParticipants": {
      "menuName": "Partecipanti al Piano"
    },
    "bonusDashboard": {
      "menuName": "Pannello"
    },
    "awardLetter": {
      "menuName": "Lettera di Premio"
    },
    "saipAllocation": {
      "menuName": "Allocazione SAIP",
      "messages": {
        "notFound": "Allocazione SAIP non trovata.",
        "saveError": "Si è verificato un errore durante il salvataggio dell'Allocazione SAIP. Riprova.",
        "saveSuccess": "Allocazione SAIP salvata con successo.",
        "deleteSuccess": "Allocazione SAIP eliminata con successo.",
        "isInUse": "L'Allocazione SAIP è in uso e non può essere eliminata.",
        "duplicateValueCode": "I valori dell'Allocazione SAIP non possono avere codici duplicati.",
        "duplicateExternalId": "Esiste già un'Allocazione SAIP con questo ID esterno.",
        "valuesSumExceeded": "I valori dell'Allocazione SAIP non possono superare il 100%."
      }
    }
  },
  "cultureTalent": {
    "menuName": "Cultura e Talento",
    "culture": {
      "menuName": "Programmi Cultura e Talento"
    },
    "talent": {
      "menuName": "Piattaforme di Formazione"
    }
  },
  "talentMapping": {
    "menuName": "Mappatura Talenti",
    "skills": {
      "menuName": "Competenze"
    },
    "orgChart": {
      "menuName": "Organigramma"
    },
    "myProfile": {
      "menuName": "Mio Profilo"
    },
    "degreeTypes": {
      "menuName": "Tipo di Titolo di Studio",
      "pageTitle": "Tipo di Titolo di Studio",
      "name": "Nome",
      "isActive": "È Attivo",
      "add": "Aggiungi Tipo di Titolo di Studio",
      "edit": "Modifica Tipo di Titolo di Studio",
      "delete": {
        "title": "Elimina Tipo di Titolo di Studio",
        "text": "Sei sicuro di voler eliminare questo Tipo di Titolo di Studio?"
      },
      "messages": {
        "created": "Tipo di Titolo di Studio creato con successo.",
        "updated": "Tipo di Titolo di Studio aggiornato con successo.",
        "deleted": "Tipo di Titolo di Studio eliminato con successo.",
        "saveError": "Si è verificato un errore durante il salvataggio del Tipo di Titolo di Studio. Riprovare.",
        "notFound": "Registro Tipo di Titolo di Studio non trovato.",
        "inUse": "Il Tipo di Titolo di Studio è in uso e non può essere eliminato."
      }
    }
  },
  "absenceRequest": {
    "menuName": "Richiesta di Assenza",
    "createRequest": {
      "menuName": "Crea Richiesta"
    },
    "viewManageRequests": {
      "menuName": "Le Mie Richieste"
    },
    "calendar": {
      "menuName": "Calendario"
    },
    "pendingRequestsAndHistory": {
      "menuName": "Approvazioni"
    },
    "manageDirectReportsHours": {
      "menuName": "Gestisci Equilibri"
    },
    "upload": {
      "menuName": "Carica"
    },
    "manageAbsenceProfiles": {
      "menuName": "Gestisci Profili Assenza"
    },
    "manageHolidays": {
      "menuName": "Gestisci Festività"
    },
    "hoursCalculationMatrices": {
      "menuName": "Matrici di Calcolo Ore"
    },
    "manageApprovingDelegate": {
      "menuName": "Delega Approvazioni"
    },
    "notification": {
      "menuName": "Notifica Assenza"
    },
    "manageMatrixCategories": {
      "menuName": "Gestisci Categorie Matrice"
    },
    "manageFloatingHolidayMatrix": {
      "menuName": "Gestisci Matrice Festività Mobile"
    },
    "manageSickMatrix": {
      "menuName": "Gestisci Matrice Malattia"
    }
  },
  "expenseReport": {
    "menuName": "Rapporti di Spesa",
    "createExpenses": {
      "menuName": "Crea Spesa"
    },
    "myExpenses": {
      "menuName": "Le Mie Spese"
    },
    "approvals": {
      "menuName": "Spese da Approvare"
    },
    "delegateApprovals": {
      "menuName": "Delega Approvazioni"
    },
    "preparers": {
      "menuName": "Preparatori"
    },
    "categories": {
      "menuName": "Categorie"
    },
    "distanceRates": {
      "menuName": "Tariffe Distanza"
    },
    "generalLedgers": {
      "menuName": "Contabilità Generale"
    },
    "policies": {
      "menuName": "Politiche"
    },
    "projects": {
      "menuName": "Progetti"
    }
  },
  "salaryExtraPay": {
    "menuName": "Pagamento Extra",
    "createRequest": {
      "menuName": "Crea Richiesta"
    },
    "myRequests": {
      "menuName": "Le Mie Richieste"
    },
    "approvals": {
      "menuName": "Approvazioni"
    },
    "delegateApprovals": {
      "menuName": "Delega Approvazioni"
    },
    "locationSetups": {
      "menuName": "Configurazioni Ubicazione"
    },
    "export": {
      "menuName": "Esporta"
    },
    "policies": {
      "menuName": "Politiche"
    },
    "payType": {
      "menuName": "Tipi di Pagamento"
    },
    "personnelAreaSetups": {
      "menuName": "Configurazioni Area Personale"
    }
  },
  "developmentPlan": {
    "menuName": "Piano di Sviluppo",
    "planDelegate": {
      "menuName": "Delega Piano"
    },
    "questions": {
      "menuName": "Domande"
    },
    "plans": {
      "menuName": "Piani"
    },
    "programs": {
      "menuName": "Programmi"
    },
    "notificationSender": {
      "menuName": "Mittente Notifica"
    },
    "fillDevelopmentPlan": {
      "menuName": "PDI"
    },
    "signEvaluations": {
      "menuName": "Firma Valutazioni"
    },
    "resultViewer": {
      "menuName": "Visualizzatore Risultati"
    }
  },
  "survey": {
    "menuName": "Sondaggio",
    "questionCategories": {
      "menuName": "Categorie Domande"
    },
    "questions": {
      "menuName": "Domande"
    },
    "ratingScales": {
      "menuName": "Scale di Valutazione"
    },
    "actionPlans": {
      "menuName": "Piano d'Azione"
    },
    "people": {
      "menuName": "Persone"
    },
    "surveys": {
      "menuName": "Moduli Sondaggio"
    },
    "notificationSender": {
      "menuName": "Mittente Notifica"
    },
    "dashboard": {
      "menuName": "Pannello"
    }
  },
  "hourlyPositions": {
    "menuName": "Posizioni Orarie",
    "createRequest": {
      "menuName": "Crea Richiesta"
    },
    "requests": {
      "menuName": "Richieste"
    },
    "employeeSubgroup": {
      "menuName": "Sottogruppo Dipendenti"
    },
    "hourlyCatalog": {
      "menuName": "Catalogo Orario"
    }
  },
  "vuestic": {
    "search": "Cerca",
    "noOptions": "Elementi non trovati",
    "ok": "OK",
    "cancel": "Annulla",
    "uploadFile": "Seleziona file",
    "undo": "Annulla",
    "dropzone": "Trascina i file qui per caricare",
    "fileDeleted": "File eliminato",
    "closeAlert": "chiudi avviso",
    "backToTop": "torna all'inizio",
    "toggleDropdown": "attiva menu a discesa",
    "carousel": "carousel",
    "goPreviousSlide": "vai alla diapositiva precedente",
    "goNextSlide": "vai alla diapositiva successiva",
    "goSlide": "vai alla diapositiva {index}",
    "slideOf": "diapositiva {index} di {length}",
    "close": "chiudi",
    "openColorPicker": "apri selettore colore",
    "colorSelection": "selezione colore",
    "colorName": "colore {color}",
    "decreaseCounter": "diminuisci contatore",
    "increaseCounter": "aumenta contatore",
    "selectAllRows": "seleziona tutte le righe",
    "sortColumnBy": "ordina colonna per {name}",
    "selectRowByIndex": "seleziona riga {index}",
    "resetDate": "reimposta data",
    "nextPeriod": "periodo successivo",
    "switchView": "cambia vista",
    "previousPeriod": "periodo precedente",
    "removeFile": "rimuovi file",
    "reset": "reimposta",
    "pagination": "paginazione",
    "goToTheFirstPage": "vai alla prima pagina",
    "goToPreviousPage": "vai alla pagina precedente",
    "goToSpecificPage": "vai alla pagina {page}",
    "goToSpecificPageInput": "inserisci numero pagina",
    "goNextPage": "vai alla pagina successiva",
    "goLastPage": "vai all'ultima pagina",
    "currentRating": "valutazione attuale {value} di {max}",
    "voteRating": "vota valutazione {value} di {max}",
    "optionsFilter": "filtro opzioni",
    "splitPanels": "dividi pannelli",
    "movePaginationLeft": "sposta paginazione a sinistra",
    "movePaginationRight": "sposta paginazione a destra",
    "resetTime": "reimposta ora",
    "closeToast": "chiudi notifica",
    "selectedOption": "Opzione selezionata",
    "noSelectedOption": "Nessuna opzione selezionata",
    "breadcrumbs": "percorso di navigazione",
    "counterValue": "valore contatore",
    "selectedDate": "data selezionata",
    "selectedTime": "ora selezionata",
    "progressState": "stato avanzamento",
    "color": "colore",
    "next": "Avanti",
    "back": "Indietro",
    "finish": "Termina",
    "step": "passo",
    "progress": "avanzamento",
    "loading": "Caricamento",
    "sliderValue": "Il valore attuale del cursore è {value}",
    "switch": "Interruttore",
    "inputField": "Campo di input",
    "fileTypeIncorrect": "Tipo file non corretto",
    "select": "Seleziona un'opzione"
  },
  "orgChart": {
    "title": "Organigramma",
    "menuTitle": "Organigramma",
    "menuName": "Organigramma",
    "organization": "Organizzazione",
    "directReports": "Rapporti Diretti",
    "showEmployeeDetails": "Mostra dettagli dipendente",
    "goUp": "Sali di un livello",
    "navigateHere": "Naviga qui",
    "vacant": "Vacante",
    "legend": {
      "active": "Attivo",
      "inactive": "Inattivo",
      "termed": "Cessato",
      "vacant": "Vacante"
    },
    "position": "Posizione",
    "plant": "Stabilimento",
    "businessArea": "Area Aziendale",
    "personnelArea": "Area Personale",
    "costCenter": "Centro di Costo",
    "hireDate": "Data di Assunzione",
    "score360": "Punteggio 360",
    "scoreGoals": "Punteggio Obiettivi",
    "score9box": "9-Box",
    "person": "Persona",
    "employeeType": "Tipo di Dipendente",
    "employeeStatus": "Stato del Dipendente",
    "status": "Stato",
    "view": "Vista",
    "viewOptions": {
      "basic": "Base",
      "performance": "Performance",
      "headcount": "Organico"
    },
    "headcount": {
      "directTotal": "Totale Diretto",
      "directSESNE": "Diretto SE/SNE",
      "total": "Totale Organico",
      "spanOfControl": "Ampiezza di Controllo",
      "se": "Dipendenti Stipendiati",
      "sne": "Dipendenti SNE",
      "hourly": "Dipendenti a Ore",
      "truck": "Autisti",
      "work": "Lavoro"
    },
    "hidePeers": "Nascondi pari",
    "showPeers": "Mostra pari",
    "collapse": "Comprimi",
    "expand": "Espandi",
    "errors": {
      "salariedTypeCannotBeRemoved": "Il tipo di retribuzione non può essere rimosso.",
      "employeeNotInTree": "Questo dipendente è al di fuori dell'Organigramma e non può essere visualizzato."
    }
  }
}
